import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Organization } from '@/lib/types';
import { useAuth } from '@/lib/auth';
import { ApiError } from '@/lib/api';
import { Button, Card, Input, Spinner } from '@/components/ui';

export function ProfilePage() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({
    fullName: user?.fullName ?? '',
    phone: user?.phone ?? '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const { data: orgs } = useQuery({
    queryKey: ['organizations'],
    queryFn: () => api<{ organizations: Organization[] }>('/organizations'),
  });

  async function handleSave(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await api('/auth/profile', {
        method: 'PUT',
        body: JSON.stringify(form),
      });
      await refreshUser();
      setMessage('Profil güncellendi');
    } catch (err) {
      setMessage(err instanceof ApiError ? err.message : 'Güncelleme başarısız');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Profil</h2>

      <Card>
        <form onSubmit={handleSave} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">E-posta</label>
            <Input value={user?.email ?? ''} disabled />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Ad Soyad</label>
            <Input
              value={form.fullName}
              onChange={(e) => setForm({ ...form, fullName: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Telefon</label>
            <Input
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
            />
          </div>
          {message && (
            <p className={`text-sm ${message.includes('başarısız') ? 'text-destructive' : 'text-success'}`}>
              {message}
            </p>
          )}
          <Button type="submit" disabled={loading}>
            {loading ? <Spinner /> : 'Kaydet'}
          </Button>
        </form>
      </Card>

      <Card>
        <h3 className="font-semibold">Organizasyonlarım</h3>
        <ul className="mt-3 space-y-2">
          {(orgs?.organizations ?? []).map((org) => (
            <li key={org.id} className="text-sm">
              {org.name}
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
